import { render, staticRenderFns } from "./w-form-radio.vue?vue&type=template&id=795eff4c&"
import script from "./w-form-radio.vue?vue&type=script&lang=js&"
export * from "./w-form-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports